function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import BasicUtils from "../../utils/basic-utils";
import { actions } from "../../utils/overlay-store";
import Button from "../elements/button";

var ModalTriggerDeprecated = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalTriggerDeprecated, _React$Component);

  var _super = _createSuper(ModalTriggerDeprecated);

  function ModalTriggerDeprecated() {
    var _this;

    _classCallCheck(this, ModalTriggerDeprecated);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "key", BasicUtils.randomKey());

    _defineProperty(_assertThisInitialized(_this), "handleLaunchModal", function (e) {
      e.preventDefault();

      if (_this.props.disable) {
        return;
      }

      var dialog = /*#__PURE__*/React.cloneElement(_this.props.modal, {
        onClose: _this.handleRemove,
        onUnmount: _this.handleRemove
      });
      actions.launchModal(dialog, _this.key);
      typeof _this.props.onClick === "function" ? _this.props.onClick() : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemove", function () {
      actions.removeModal(_this.key); // reset the key once it's removed in case launch again from same trigger

      _this.key = BasicUtils.randomKey();
    });

    return _this;
  }

  _createClass(ModalTriggerDeprecated, [{
    key: "render",
    value: function render() {
      if (this.props.children) {
        var additionalProps = _.omit(this.props, "modal", "disable");

        return /*#__PURE__*/React.createElement(Button, _.extend({}, additionalProps, {
          onClick: this.handleLaunchModal,
          disabled: this.props.disable,
          type: this.props.buttonType
        }), this.props.children);
      }

      return null;
    }
  }]);

  return ModalTriggerDeprecated;
}(React.Component);

_defineProperty(ModalTriggerDeprecated, "displayName", "ModalTriggerDeprecated");

_defineProperty(ModalTriggerDeprecated, "propTypes", {
  modal: PropTypes.element.isRequired,
  disable: PropTypes.bool,
  onClick: PropTypes.func,
  buttonType: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
});

_defineProperty(ModalTriggerDeprecated, "defaultProps", {
  buttonType: "simple"
});

export default ModalTriggerDeprecated;